import React, { useEffect, useState, useCallback } from 'react';
import { ShieldCheck, RefreshCw, AlertOctagon } from 'lucide-react';
import { format } from 'date-fns';
import { api } from '../../lib/api';
import { Card, LoadingState, EmptyState, ErrorState } from '../../components/control-center/StateWrappers';
import { Button } from '../../components/ui/button';

const fmtDate = (iso) => { try { return iso ? format(new Date(iso), 'dd/MM/yyyy HH:mm') : '—'; } catch { return '—'; } };
const val = (o, ...keys) => { for (const k of keys) if (o?.[k] !== undefined && o?.[k] !== null && o?.[k] !== '') return o[k]; return null; };

const Errors = () => {
  const [state, setState] = useState({ loading: true, error: false, rows: [] });
  const load = useCallback(async () => {
    setState((s) => ({ ...s, loading: true, error: false }));
    try {
      const { data } = await api.get('/control-center/errors');
      setState({ loading: false, error: false, rows: Array.isArray(data) ? data : [] });
    } catch { setState({ loading: false, error: true, rows: [] }); }
  }, []);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="max-w-5xl mx-auto">
      <div className="flex items-start sm:items-center justify-between flex-col sm:flex-row gap-3 mb-6">
        <div>
          <h1 className="text-2xl md:text-3xl font-bold text-slate-900">Incidencias</h1>
          <p className="text-slate-500 text-sm mt-1">Errores activos que requieren atención.</p>
        </div>
        <Button onClick={load} className="bg-white text-slate-800 border border-slate-200 hover:bg-slate-50 gap-2">
          <RefreshCw className={`w-4 h-4 ${state.loading ? 'animate-spin' : ''}`} /> Actualizar
        </Button>
      </div>

      {state.loading && <LoadingState />}
      {state.error && !state.loading && <ErrorState onRetry={load} />}
      {!state.loading && !state.error && state.rows.length === 0 && (
        <Card className="p-10 flex flex-col items-center text-center" data-testid="errors-empty">
          <div className="w-12 h-12 rounded-xl bg-green-50 text-green-600 flex items-center justify-center mb-4">
            <ShieldCheck className="w-6 h-6" />
          </div>
          <p className="text-slate-900 font-semibold">No hay incidencias activas.</p>
          <p className="text-slate-500 text-sm mt-1">Todo funciona con normalidad.</p>
        </Card>
      )}
      {!state.loading && !state.error && state.rows.length > 0 && (
        <div className="space-y-3">
          {state.rows.map((r, i) => (
            <Card key={i} className="p-5" data-testid={`error-item-${i}`}>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-lg bg-red-50 text-red-600 flex items-center justify-center shrink-0">
                  <AlertOctagon className="w-5 h-5" />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-x-3 gap-y-1 mb-1">
                    <span className="font-semibold text-slate-900">{val(r,'workflow_name','workflow') || '—'}</span>
                    {val(r,'node_name','node') && <span className="text-xs text-slate-500 bg-slate-100 rounded px-2 py-0.5">{val(r,'node_name','node')}</span>}
                    <span className="text-xs text-slate-500 ml-auto">{fmtDate(val(r,'fecha','date','created_at'))}</span>
                  </div>
                  <p className="text-slate-700 text-sm leading-relaxed break-words">
                    {val(r,'error_message','message') || '—'}
                  </p>
                </div>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default Errors;
